import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-portal-home-company',
  templateUrl: './portal-home-company.component.html',
  styleUrls: ['./portal-home-company.component.scss']
})
export class PortalHomeCompanyComponent implements OnInit {


  responsiveOptions: {
    breakpoint?: string
    numVisible?: number
    numScroll?: number
  }[];

  images = [
    '/assets/images/boat.jpg',
    '/assets/images/tanzanite-bridge.jpg',
    '/assets/images/rock.jpg',
    '/assets/images/island.jpg'
  ]

  serviceProviders = [
    { title: 'eGA', image: '/assets/images/ega.png'},
    { title: 'TRC', image: '/assets/images/trc.png'},
    { title: 'MOI', image: '/assets/images/moi.png'},
    { title: 'TCU', image: '/assets/images/tcu.png'},
    { title: 'ATCL',image: '/assets/images/atcl.png'},
    { title: 'TBC', image: 'assets/images/tbc.png'},
    { title: 'TPA', image: '/assets/images/tpa.png'},
    { title: 'TBA', image: '/assets/images/tba.png'},
    { title: 'eGA', image: '/assets/images/ega.png'},
    { title: 'TRC', image: '/assets/images/trc.png'},
    { title: 'MOI', image: '/assets/images/moi.png'},
    { title: 'TCU', image: '/assets/images/tcu.png'},
    { title: 'TPA', image: '/assets/images/tpa.png'},
    { title: 'TBA', image: '/assets/images/tba.png'},
  ]

  sectors = [
    { title: 'Afya', icon: 'health'},
    { title: 'Sheria', icon: 'law'},
    { title: 'Elimu', icon: 'book'},
    { title: 'Kilimo', icon: 'agriculture'},
    { title: 'Uhamiaji',icon: 'migration'},
    { title: 'Leseni', icon: 'licence'},
    { title: 'Afya', icon: 'health'},
    { title: 'Sheria', icon: 'law'},
    { title: 'Elimu', icon: 'book'},
    { title: 'Kilimo', icon: 'agriculture'},
    { title: 'Uhamiaji',icon: 'migration'},
    { title: 'Leseni', icon: 'licence'},
    { title: 'Afya', icon: 'health'},
    { title: 'Sheria', icon: 'law'},
    { title: 'Elimu', icon: 'book'},
    { title: 'Kilimo', icon: 'agriculture'},
    { title: 'Uhamiaji',icon: 'migration'},
    { title: 'Leseni', icon: 'licence'}
  ]

  services = [
    { title: 'VIBALI',  color: "#3399FF" },
    { title: 'BIMA', color: "#F9B115" },
    { title: 'LESENI', color: "#2EB85C" },
    { title: 'HATI', color: "#ffffff" },
    { title: 'KODI', color: "#3399FF" },
    { title: 'AFYA', color: "#F9B115" },
    { title: 'ARDHI', color: "#800000" }
  ]

  serviceFilters = [
    { name: 'Citizens', value: 'Citizens' },
    { name: 'Foreigners', value: 'Foreigners' },
    { name: 'Investors', value: 'Investors' },
    { name: 'Students', value: 'Students' }
  ]

  mostSearched = [
    { name: "Boda boda", value: "Boda boda" },
    { name: "TIN number", value: "TIN number" },
    { name: "Hati ya kusafiria", value: "Hati ya kusafiria" },

  ]
  constructor() { }

  ngOnInit(): void {
    this.responsiveOptions = [
      {
          breakpoint: '1024px',
          numVisible: 3,
          numScroll: 3
      },
      {
          breakpoint: '768px',
          numVisible: 2,
          numScroll: 2
      },
      {
          breakpoint: '560px',
          numVisible: 1,
          numScroll: 1
      }
  ];
  }

  scrollDiv(n) {
    document.getElementById("preview").scrollLeft += 500 * n ;
  }

  scrollServices(n) {
    document.getElementById("serviceId").scrollLeft += 500 * n ;
  }

  scrollProviders(n){
    document.getElementById("providers").scrollLeft += 500 * n ;

  }

  scrollPopularServices(n){
    document.getElementById("popularId").scrollLeft += 500 * n ;
  }
}
